import React from "react";
var __jsx = React.createElement;
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var SearchUspLearnMore = function SearchUspLearnMore(_ref) {
  var onClose = _ref.onClose,
    src = _ref.src,
    open = _ref.open,
    title = _ref.title,
    description = _ref.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center  gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-3 flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "",
    loading: "lazy",
    width: "72px",
    height: "72px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-xl font-bold text-primary text-center"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "text-primary font-regular leading-7 text-base text-center"
  }, description))), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/car-purchase-terms-conditions"),
    className: "text-center text-[#6D7A8D] text-sm font-medium underline cursor-pointer hover:text-primary transition-colors duration-200 ease-in active:text-[#6D7A8D] lg:text-base"
  }, t("تطبق الشروط والأحكام", {
    ns: "web_post_view"
  }))))));
};
export default SearchUspLearnMore;